<template>
  <li v-bind:id="id" v-bind:class="{'active': active, 'disabled': disabled, 'errors': errors}" ref="app">
    <span v-if="disabled">{{value}}<small v-if="errors" class="ms-2">({{ bundle.id_11804.replace("{0}", errors) }})</small></span>
    <a v-else="" href="#" v-on:click.prevent="goto(value)">{{value}}<small v-if="errors" class="ms-2">({{ bundle.id_11804.replace("{0}", errors) }})</small></a>
    <transition name="slide-fade">
      <div v-show="active">
        <slot/>
        <div v-if="next" class="mt-4 mb-2">
          <button v-on:click.prevent="goto(next)" class="btn btn-primary">{{ bundle.id_12256 }}</button>
        </div>
      </div>
    </transition>
  </li>
</template>

<script>
import Vue from "vue";

export default {
  name: "steps",
  props: ["id", "value", "next", "current", "disabled", "errors"],
  data: function () {
    return {
      bundle: {
        id_11804: "{0} error(s)",
        id_12256: "Next"
      }
    }
  },
  computed: {
    active: function () {
      return this.current == this.value;
    }
  },
  methods: {
    goto: function (value) {
      // Goto if not already active. Otherwise unselect.
      this.$emit("goto", !this.active || this.value != value ? value : null);
      // Some components need to position themselves absolute and fail to do so, when the step they are under is not
      // the active one. Upon opening a step with components like that, we need to "tell" those components that things
      // have changed. We do that with a resize event.
      this.$nextTick(() => {
        window.dispatchEvent(new Event("resize"));
        try {
          const app = this.$refs.app;
          const rect = app.getBoundingClientRect();
          const top = rect.top - 150; // The 150 extra is for our top menu.
          if (top < 0) {
            window.scrollBy(0, top);
          }
        } catch (err) {
          console.log(err);
        }
      });
    }
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
  }
}
</script>
